<div class="progress-container">
  <div class="adoption-stage-title">
    <h1>Adoption stage of the organization</h1>
    <mat-icon
      class="info-icon"
      matTooltip="As the initiative progresses, the organization moves through three stages: preparation, implementation, and
sustainment."
      matTooltipPosition="above"
    >
      info
    </mat-icon>
  </div>
</div>
<div class="progress-container">
  <ng-container *ngFor="let step of steps; let i = index">
    <div class="step">
      <div class="circle" [class.active]="value > i">
        <span *ngIf="value > i" class="check">&#10003;</span>
      </div>
      <div class="label">{{ step.label }}</div>
    </div>
    <div
      *ngIf="i < steps.length - 1"
      class="line"
      [class.active]="value > i"
    ></div>
  </ng-container>
</div>
